// Landing ("thank you") render of the pillows generic FormPage. Same shell as
// FormPageTemplate, but content__copy holds the thank-you rich text instead of
// the form. (#33285)
import React from "react";
import { jt } from "ttag";

import { templates } from "@reactivated";

import { EditorContent } from "@thelabnyc/thelabui/src/components/EditorContent";

import { PageSkeleton } from "../components/PageSkeleton";
import { SideNav } from "../components/SideNav";

export const Template = (
    props: templates.FormPageLandingTemplate,
): React.JSX.Element => {
    const {
        has_nav,
        side_nav,
        has_right_bar,
        right_bar,
        content_title,
        phone_display,
        phone_href,
        thank_you_html,
    } = props;
    // ttag's `jt` forbids a conditional/logical expression directly inside the
    // `${...}` interpolation, so compute the optional phone link first.
    const phoneLink = phone_display ? (
        <a key="phone" href={phone_href}>
            {phone_display}
        </a>
    ) : null;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
                {has_nav && (
                    <div className="l-side-nav">
                        <SideNav items={side_nav} />
                    </div>
                )}

                <div className="l-side-nav-content">
                    <div className="content-title">
                        <h1 className="content-title__headline">
                            {content_title}
                        </h1>
                        <span className="content-title__info">
                            {jt`Talk to Sleep Expert ${phoneLink}`}
                        </span>
                    </div>

                    <div
                        className={
                            has_right_bar
                                ? "content__copy"
                                : "content__copy--full-width"
                        }
                    >
                        <div>
                            <div
                                className="rich-text"
                                dangerouslySetInnerHTML={{
                                    __html: thank_you_html,
                                }}
                            />
                        </div>
                    </div>

                    {has_right_bar && (
                        <aside className="content__aside">
                            {right_bar.map((item, i) =>
                                item.block_type === "right_bar_section" ? (
                                    <div
                                        key={i}
                                        className={`w-block-${item.block_type} block-${item.block_type}`}
                                    >
                                        <h1 className="content__aside__title">
                                            {item.header}
                                        </h1>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: item.body_html,
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <EditorContent key={i}>
                                        {(marker) => (
                                            <div
                                                className={`w-block-${item.block_type} block-${item.block_type}`}
                                                dangerouslySetInnerHTML={{
                                                    __html: item.body_html,
                                                }}
                                                {...marker}
                                            />
                                        )}
                                    </EditorContent>
                                ),
                            )}
                        </aside>
                    )}
                </div>
            </div>
        </PageSkeleton>
    );
};
